import { render, staticRenderFns } from "./CountryDetails.vue?vue&type=template&id=a6fab018&scoped=true"
import script from "./CountryDetails.vue?vue&type=script&lang=js"
export * from "./CountryDetails.vue?vue&type=script&lang=js"
import style0 from "./CountryDetails.vue?vue&type=style&index=0&id=a6fab018&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6fab018",
  null
  
)

export default component.exports